__turbopack_context__.v({
  "className": "archivo_black_756988c1-module__F0zqbq__className",
  "variable": "archivo_black_756988c1-module__F0zqbq__variable",
});
